import { z } from "zod";
import type { Operation } from "../types";

/**
 * Cross-product bug reporting (docs/bug-report/PRD.md §5) — the web-shell
 * proxy contract. The route forwards to the shared `@excellent/core/bug-report`
 * client server-side (so the browser never talks to excellent.so directly),
 * stamping product/version/platform/context itself; the client only supplies
 * what the user typed.
 */

const bugReportBody = z.object({
  title: z.string().min(1).max(200),
  description: z.string().max(10_000).optional(),
  severity: z.enum(["low", "medium", "high"]).optional(),
  contact_email: z.string().optional(),
  /** Current page path (e.g. `/settings/user`) — one context key, PRD §5. */
  route: z.string().optional(),
});
export type BugReportBody = z.infer<typeof bugReportBody>;

const bugReportResponse = z.object({
  ok: z.boolean(),
  id: z.string().optional(),
  error: z.string().optional(),
});
export type BugReportResponse = z.infer<typeof bugReportResponse>;

const submitOp: Operation<void, void, BugReportBody, BugReportResponse> = {
  method: "POST",
  path: () => "/api/bug-report",
  body: bugReportBody,
  response: bugReportResponse,
};

export const bugReport = {
  submit: submitOp,
};
